import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M20 18v-1h1.99L22 3H2v14h2v1H0v2h24v-2h-4zM4 5h16v10H4V5z"
}), 'LaptopWindowsSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/LaptopWindowsSharp.js
// module id = 4418
// module chunks = 2